module.exports = __webpack_public_path__ + "img/71.3cb7414e.png";